<script>
  import { onMount } from 'svelte'
  import Header from '../header.svelte'
  import MediaQuery from '../MediaQuery.svelte'
  export let content

  let glyphset
  onMount(() => {
    const glyphsetLines = gsap.utils.toArray(
      document.querySelectorAll('.glyphset-line')
    )
    glyphsetLines.forEach((e) => {
      gsap.from(e, {
        opacity: 0,
        y: -60,
        scrollTrigger: {
          trigger: e,
          start: 'top bottom',
          toggleActions: 'play none none reverse',
        },
      })
    })

    const alternateLines = gsap.utils.toArray(
      document.querySelectorAll('.line-alternates')
    )
    alternateLines.forEach((e) => {
      gsap.from(e, {
        opacity: 0,
        scrollTrigger: {
          trigger: e,
          toggleActions: 'play none none reverse',
          start: 'top bottom',
          onEnter: () => {
            for (let i = 0; i < e.children.length; i++) {
              gsap.from(e.children[i], {
                x: -40,
                duration: 0.4 * i,
              })
            }
          },
        },
      })
    })
  })
</script>

<MediaQuery query="(min-width: 600px)" let:matches>
  {#if matches}
    <div class="glyphset" bind:this={glyphset}>
      {#each content.glyphset as line}
        <img class="glyphset-line" src={line} alt="Arteria Glyphset" />
      {/each}
    </div>
  {/if}
</MediaQuery>

<MediaQuery query="(max-width: 599px)" let:matches>
  {#if matches}
    <div class="glyphset">
      {#each content.glyphset_mobile as line}
        <img class="glyphset-line" src={line} alt="Arteria Glyphset" />
      {/each}
    </div>
  {/if}
</MediaQuery>

<Header title="Alternates" />
<div class="cols4-wrapper">
  {#each content.lines as line}
    <div class="line-alternates">
      {#each line as col, j}
        <div class="col-{j + 1}"><img src={col} alt="" /></div>
        {#if j !== line.length - 1}
          <div class="arrow"><img src={content.arrow} alt="" /></div>
        {/if}
      {/each}
    </div>
  {/each}
</div>

<style lang="scss">
  @import '../../responsive.scss';

  .glyphset {
    margin-bottom: 100px;
  }
  .line-alternates {
    grid-column: 1 / span 2;
    display: grid;
    grid-template-columns: 1fr 0.37fr 1fr 0.37fr 1fr;

    @include for-phone {
      grid-column: 1 / span 3;
    }
  }
</style>
